export const GET_LIST_PERMISSION = process.env.VUE_APP_API_URL+'/permission';
export const GET_USER = process.env.VUE_APP_API_URL+'/users';
export const GET_USER_COURSE_TRANSFER = process.env.VUE_APP_API_URL+'/course-transfers/search-user';
